(function () {
    'use strict';

    angular.module('app').controller('IndexController', SimpleIndexController);

    SimpleIndexController.$inject = ['$scope', 'settingsService',];
    function SimpleIndexController($scope, settingsService) {

        $scope.toggleLoginDiv = ($event) => {
            settingsService.showLogin = !settingsService.showLogin;
            $event.stopPropagation();
        };

        $scope.removeLoginDiv = () => {
            settingsService.showLogin = false;
        };
    }
})();
